import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const ViewsDetails = styled(Typography)`
  color: white;
  background-color: #85A9F0;
  font-size: 12px;
  border-radius: 4px;
  padding: 0 8px;
  margin-left: 10px;
  opacity: 0;
  transition: 300ms;
`;

export const Container = styled.div`
  background-color: white;
  padding: 20px;
  cursor: pointer;

  &:hover ${ViewsDetails} {
    opacity: 1;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Author = styled(Typography)`
  color: black;
  font-weight: bold;
`;

export const CreationDate = styled(Typography)`
  color: black;
  margin-left: auto;
`;

export const Text = styled(Typography)`
  color: black;
  text-align: left;
  font-size: 1em;
`;
